const getErrorMessage = (e: Error) => {
  return e.message ? e.message : "Request failed";
};

export default getErrorMessage;
